// Maps raw role keys (e.g. "tagchairman", "bookconvener") to nicely spelled-out
// labels for display, e.g. in the "… by <Role>'s Desk" page headers.

const ROLE_LABELS: Record<string, string> = {
    dess: 'DESS',
    tagchairman: 'Tag Chairman',
    bookconvener: 'Book Convener',
    journalconvener: 'Journal Convener',
    thematicarealeader: 'Thematic Area Leader',
    tagthematicareamember: 'Thematic Area Member',
};

/**
 * Returns a human-friendly label for a role.
 * Known roles are spelled out; unknown roles fall back to the raw value.
 */
export function formatRoleLabel(role?: string | null): string {
    if (!role) return '';
    const key = role.toLowerCase().replace(/[\s_-]/g, '');
    return ROLE_LABELS[key] ?? role.trim();
}
